import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import RelevoDePerfilForm from "./RelevoDePerfilForm";
import UploadRelevoDePerfil from "./UploadRelevoDePerfil";

const RelevoDePerfilModal = ({ toggle, isOpen, upload, clientId, reloadRelevos, infoRow }) => {
  const { id } = infoRow || {};
  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal size="lg" isOpen={isOpen}>
        <ModalHeader toggle={toggle}>Nuevo Relevo de Perfil</ModalHeader>
        <ModalBody style={{ backgroundColor: "#f8f8f8" }}>
          {upload ? (
            <UploadRelevoDePerfil toggle={toggle} clientId={clientId} relevoId={id} reloadRelevos={reloadRelevos} />
          ) : (
            <RelevoDePerfilForm toggle={toggle} clientId={clientId} relevoId={id} reloadRelevos={reloadRelevos} />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RelevoDePerfilModal;
